customElements.get("product-model-view") ||
    customElements.define(
        "product-model-view",
        class extends HTMLElement {
            constructor() {
                super();
            }
            connectedCallback() {
                (this.getParam = "view-option"), this.getElements(), this.addEventListeners(), this.querySelector(".active") || this.querySelector("[data-default-view]").classList.add("active");
            }
            addOrUpdateURLParam(key, value) {
                const searchParams = new URLSearchParams(window.location.search);
                searchParams.set(key, value);
              //alert("url");
                const newSearchParams = searchParams.toString();
                history.pushState({ newSearchParams }, "", `${window.location.pathname}${newSearchParams && "?".concat(newSearchParams)}`);
            }
            getElements() {
                (this.productView = this.querySelector("[data-product-view]")),
                    (this.modelView = this.querySelector("[data-model-view]")),
                    (this.maleView = this.querySelector("[data-male-view]")),
                    (this.femaleView = this.querySelector("[data-female-view]")),
                    (this.videoView = this.querySelector("[data-video-view]"));
            }
            toggleProductModelViewButton(option) {
                this.querySelector(".active")?.classList.remove("active"),
                    this.querySelector(`.${option}-view-button`).classList.add("active"),
                    this.setImageSourcesBasedOnProductViewOption(option),
                    (document.querySelector("#ProductsList").dataset.nextUrl = window.location.pathname + window.location.search);
              //alert("df"+option);
            }
            setImageSourcesBasedOnProductViewOption(option) {
                this.productGridItems = this.closest(`#shopify-section-${this.dataset.uniqueId}`).querySelectorAll(".product-card");
              
                for (const productGridItem of this.productGridItems) {
                  let dataHoverImg_1 = productGridItem.querySelector(".product-card__image-hover-1").getAttribute("data-card-image-block");
                  let dataHoverImg_2 = productGridItem.querySelector(".product-card__image-hover-2").getAttribute("data-card-image-block");
                  //alert("item"+dataHoverImg_1+" = "+dataHoverImg_2);

                  if(option=="product"){
                      productGridItem.querySelector(".product-card__image-hover-1").classList.remove("product-card__image--second", "inset-full", "hidden","md:block");
                      productGridItem.querySelector(".product-card__image-hover-2").classList.remove("product-card__image--main");
                      productGridItem.querySelector(".product-card__image-hover-1").className += " product-card__image--main";
                      productGridItem.querySelector(".product-card__image-hover-2").className += " product-card__image--second inset-full hidden md:block";                    
                  }else{
                      productGridItem.querySelector(".product-card__image-hover-1").classList.remove("product-card__image--main");
                      productGridItem.querySelector(".product-card__image-hover-2").classList.remove("product-card__image--second", "inset-full", "hidden","md:block");
                      productGridItem.querySelector(".product-card__image-hover-1").className += " product-card__image--second inset-full hidden md:block";                                        
                      productGridItem.querySelector(".product-card__image-hover-2").className += " product-card__image--main";
                  }
                  
        
                }
            }
            _onClickHandle(e) {
                if (!e.target.dataset.view) return;
                let option = e.target.dataset.view;
                this.hasAttribute("data-save-view-option") && (this.addOrUpdateURLParam(this.getParam, option))
                    this.toggleProductModelViewButton(option);
            }
            addEventListeners() {
                this.addEventListener("click", this._onClickHandle.bind(this));
            }
        }
    );


const searchParams = new URLSearchParams(window.location.search);

let params = new URL(document.location.toString()).searchParams;
let name = params.get("view-option");

if (typeof(name) != 'undefined' && name != null){
    let name_switch = document.querySelectorAll(`.product-view-buttons-container [data-view="${name}"].switch-button`);
    // Create a new 'change' event
    var event = new Event('click');
    name_switch[0].dispatchEvent(new Event("click", { bubbles: true }));
}else{
    name = document.querySelector(`.product-view-buttons-container`).getAttribute("data-default-view");
    let name_switch = document.querySelectorAll(`.product-view-buttons-container [data-view="${name}"].switch-button`);
    // Create a new 'change' event
    var event = new Event('click');
    name_switch[0].dispatchEvent(new Event("click", { bubbles: true }));  
}